import React, { useContext, useEffect } from "react";

// Data contexts
import { ObservationFormContext } from "../hooks/ObservationFormContext";
import { TMDataContext } from "../../utils/custom_hooks/TMDataContext";

//React components
import { AchievementTargetInput } from "../common/components/AchievementTargetInput";
import { AchievementConditions } from "../common/components/AchievementConditions";
import { AchievementThresholdInput } from "../common/components/AchievementThresholdInput";
import { GoalMeasurementId } from "./GoalMeasurementId";
import { GoalOccurrence } from "../common/components/GoalOccurrence";
import { GoalNameInput } from "../common/components/GoalNameInput";

//JS Classes
import { ObservationGoalTemplate } from "../classes/goal_template_observation_class";
import { Measurement } from "../classes/measurements/measurement";
import { ObservationFormPropsShape } from "../interfaces/componentTypes";
import { GoalDescriptionInput } from "../common/components/GoalDescriptionInput";
import { LeaderBoardSelector } from "../common/components/LeaderBoardSelector";

export const ObservationForm: React.FunctionComponent<ObservationFormPropsShape> = ({
  setStepComplete,
  formPrompt,
  setFormPrompt,
}) => {
  const { DBObject } = useContext(TMDataContext);
  const { goalState, setGoalState } = useContext(ObservationFormContext);

  //Detect if Form is complete
  useEffect(() => {
    setStepComplete(ObservationGoalTemplate.complete(goalState));
  }, [goalState]);

  //Prevent propagation and event bubbling errors in React synthetic DOM
  useEffect(() => {
    var newSelector = document.getElementById("goal-frequency-selector");
    newSelector.addEventListener("keydown", (event) => {
      if (
        goalState.occurrenceFrequency &&
        $(newSelector).val() == goalState.occurrenceFrequency.id &&
        event.key == "Enter"
      ) {
        event.preventDefault();
      }
    });
  }, [goalState.occurrenceFrequency]);

  const updateAchievementTarget = (value: number): any => {
    setGoalState({
      ...goalState,
      achievementTarget: value,
    });
  };

  const handleGoalName = (e) => {
    setGoalState({
      ...goalState,
      name: e.target.value,
    });
  };

  const handleGoalDescription = (e) => {
    setGoalState({
      ...goalState,
      description: e.target.value,
    });
  };

  const handleMeasurementId = (measurementId) => {
    setGoalState({
      ...goalState,
      measurementId: measurementId,
      achievementTarget: null,
    });
    setFormPrompt(true);
  };

  const handleGoalAchievementCondition = (e) => {
    setGoalState({
      ...goalState,
      achievementCondition: e,
    });
  };

  const handleAchievementThreshold = (value: number | null): void => {
    setGoalState({
      ...goalState,
      achievementThreshold: value,
    });
  };

  const handleLeaderboardSelection = (value) => {
    setGoalState({
      ...goalState,
      leaderboardEnabled: value.target.checked,
    });
  };

  const displayMeasurementUnits = () => {
    if (!Measurement.findById(goalState.measurementId)) return "";
    return Measurement.findById(goalState.measurementId).unitsOnly();
  };

  return (
    <>
      <div className="row w-100" style={{ flex: 1 }}>
        <div className="col-md-12 col-sm-6">
          <GoalNameInput
            handleGoalName={handleGoalName}
            input={goalState.name}
            user={DBObject.User}
            type={goalState.type}
            characterLimit={DBObject.ConfigVariables.goal_name_character_limit}
          />
          <GoalDescriptionInput
            input={goalState.description}
            handleGoalDescription={handleGoalDescription}
            characterLimit={DBObject.ConfigVariables.goal_name_character_limit}
          />
          <GoalMeasurementId
            DBObject={DBObject}
            handleSelect={handleMeasurementId}
            goalState={goalState}
          />
          <AchievementTargetInput
            handleAchievementTarget={updateAchievementTarget}
            achievementTarget={goalState.achievementTarget}
            measurementUnit={displayMeasurementUnits()}
            measurementId={goalState.measurementId}
            approved={formPrompt}
          />
          <AchievementConditions
            handleSetCondition={handleGoalAchievementCondition}
            achievementTarget={
              goalState.achievementTarget ? goalState.achievementTarget : "--"
            }
            measurementUnit={displayMeasurementUnits()}
            approved={formPrompt}
          />
          <AchievementThresholdInput
            handleAchievementThreshold={handleAchievementThreshold}
            approved={formPrompt}
          />
          <GoalOccurrence
            approved={formPrompt}
            contextOrigin={ObservationFormContext}
          />
          {DBObject.ConfigVariables.leaderboards_enabled == "true" ? (
            <LeaderBoardSelector
              handleLeaderboardSelection={handleLeaderboardSelection}
              leaderboardStatus={goalState.leaderboardEnabled}
              approved={formPrompt}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};
